import { MspModel } from '../MspModel';

export class BudgetSLA extends MspModel {
    public ownerNotificationDelay: number;
    public ownerNotificationEscalation: boolean;
    public ownerNotificationMaxCount: number;
    public ownerEscalationRecipient?: string;
    public creatorNotificationDelay: number;
}
